import { render, staticRenderFns } from "./iq.vue?vue&type=template&id=8413d926&scoped=true&"
import script from "./iq.vue?vue&type=script&lang=js&"
export * from "./iq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8413d926",
  null
  
)

export default component.exports